import React, { useEffect, useState } from 'react';
import { ChakraProvider, theme } from '@chakra-ui/react';
import Gallery from './Gallery';
import { getAllCollection, getSelfieAllCollection } from '../apis/Events';
import { getCartCollection } from '../apis/Cart';
import { useStore, useStoreActions, useStoreState } from 'easy-peasy';
import Store from '../modals';
import { debounce } from 'lodash-es';

const AllGallery = props => {
  const [localEventsCollection, setLocalEventCollection] = useState([]);
  const [eventsData, setEventData] = useState([]);
  const userProfile = useStoreState(state => state.userProfile);
  const tempUser = useStoreState(state => state.tempUser);
  const isUserLogged = useStoreState(state => state.isUserLogged);
  const eventCollection = useStoreState(state => state.eventCollection);
  const [errorMessage, setErrorMessage] = useState(null);
  const [limitError, setLimitError] = useState(false);
  const { id } = props.match.params;
  const handleEventDetails = useStoreActions(store => store.handleEventDetails);
  const handleEventCollection = useStoreActions(store => store.handleEventCollection);
  const resetEventCollection = useStoreActions(action => action.resetEventCollection);

  const [eventsCart, setEventsCart] = useState([]);
  const handleSingleLevelTempCart = useStoreActions(action => action.handleSingleLevelTempCart);

  var counter = 0;
  var no_more_call = 0;

  function fetchEventCollection() {
    if (isUserLogged) {
      getAllCollection(
        userProfile.api_key,
        id,
        userProfile.user_profile_id,
        counter
      ).then(response => {
        if (!response.error && response.collection_object?.length > 0) {
          let transData = [];
          if (Boolean(response.collection_object?.length)) {
            response.collection_object.map((i, index) => {
              transData.push({ ...i, isSelected: false, isUnSelected: true });
              return null;
            });
          }
         console.log('counter',counter);
          if(counter==1)
          resetEventCollection([]);
         
          handleEventCollection(transData);
          setLocalEventCollection(transData);      
          handleEventDetails(response.data[0]);
          setEventData(response.data[0]);
          console.log('transData', transData, 'eventData', response.data[0]);
        } else {
          no_more_call=1;
          (counter > 1) ? setLimitError(true) : setErrorMessage(response.message);
        }
      });
    } else {
      getSelfieAllCollection(id, tempUser.session_id, counter).then(response => {
        if (!response.error) {
          let transData = [];
          if (Boolean(response.collection_object?.length)) {
            response.collection_object.map((i, index) => {
              transData.push({ ...i, isSelected: false, isUnSelected: true });
              return null;
            });
          }

          handleEventCollection(transData)
          console.log(transData);
          handleEventDetails(response.data[0]);
          setEventData(response.data[0]);
        } else {
          (counter > 1) ? setLimitError(true) : setErrorMessage(response.message);
        }
      });
    }
  }

  


  useEffect(() => {
    if(counter<2)
    {
     fetchEventCartItems();

    

  }
  }, [])
 

  function fetchEventCartItems() {
    getCartCollection(
      userProfile.api_key,
      id,
      userProfile.user_profile_id,
      0
    ).then(response => {
      if (!response.error) {
        let transData = [];
        if (Boolean(response.collection_object?.length)) {
          response.collection_object.map((i, index) => {
            transData.push({ ...i, isSelected: false, isUnSelected: true });
            return null;
          });
        }
        let morphData = transData.flat()
        setEventsCart(transData);
      
        handleSingleLevelTempCart(morphData);
      //  props.setCount(response.data[0].cart_photos_count);
        setErrorMessage(null);
      } else {
        setErrorMessage(response.message);
      }
    });
  }


  function updateCounter(){
    console.log('counter value',counter);
    console.log('nomore call value',no_more_call);
    if(no_more_call==0)
    {
      fetchEventCollection(counter+1)
      counter = counter+1
    }
 
  }


  const debounceCollectionCall = debounce(updateCounter, 300);

  return (
    <ChakraProvider theme={theme}>
      <Gallery
        id={id}
        error={errorMessage}
        limitError={limitError}
        event={eventsData}
        collection={eventCollection}
        fetchMore={debounceCollectionCall}
       
        Status={'AllGallery'}
        CartCount={props.CartItemCount}
      />
    </ChakraProvider>
  );
};
export default AllGallery;
